import React from "react";
import {useOverrides, Override} from "@quarkly/components";
import {Image, Box, Text, Section} from "@quarkly/widgets";

const defaultProps = {
    "padding": "48px 0 48px 0",
    "sm-padding": "60px 0 60px 0",
    "quarkly-title": "CDZVBenefits",
    "background": "transparent"
};
const overrides = {
    "box": {
        "kind": "Box",
        "props": {
            "width": "50%",
            "lg-width": "100%",
            "lg-margin": "0px 0px 0px 0px",
            "margin": "0px 0px 0px 0px",
            "lg-padding": "0px 0px 0px 0px",
            "lg-justify-content": "center",
            "pointer-events": "none",
            "padding": "0px 0 0px 0",
            "flex": "0 1 auto",
            "order": "0",
            "display": "flex",
            "text-align": "center",
            "position": "relative"
        }
    },
    "image": {
        "kind": "Image",
        "props": {
            "src": "https://uploads.quarkly.io/665dd05e1d712a0023346c54/images/btc_strategy.png?v=2024-06-03T15:59:19.333Z",
            "object-fit": "cover",
            "sm-min-height": "100vw",
            "disableOptimization": false,
            "pointer-events": "none",
            "transition": "transform 0.5s ease-in-out 0s",
            "transform": "translateY(10px)",
            "hover-transform": "translateY(0px)",
            "align-self": "center"
        }
    },
    "box1": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "width": "50%",
            "flex-direction": "column",
            "align-items": "flex-start",
            "lg-width": "100%",
            "lg-align-items": "flex-start",
            "lg-margin": "0px 0px 0px 0px",
            "padding": "48px 10px 8px 64px",
            "justify-content": "center",
            "background": "transparent",
            "md-padding": "36px 40px 8px 40px",
            "sm-padding": "36px 24px 8px 24px",
            "order": "1"
        }
    },
    "text": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "color": "#ffffff",
            "font": "normal 700 24px/1.3 --fontFamily-sans",
            "lg-text-align": "left",
            "sm-text-align": "left",
            "children": "What's missing in TradingView"
        }
    },
    "text1": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 40px 0px",
            "color": "rgba(255, 255, 255, 0.7)",
            "font": "normal 400 16px/1.5 --fontFamily-sans",
            "lg-text-align": "left",
            "sm-text-align": "left",
            "children": "Create complex entry and exit conditions right on the chart without any coding."
        }
    },
    "text2": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "color": "#ffffff",
            "font": "normal 700 24px/1.3 --fontFamily-sans",
            "lg-text-align": "left",
            "sm-text-align": "left",
            "children": "Risk-free idea testing"
        }
    },
    "text3": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 40px 0px",
            "color": "rgba(255, 255, 255, 0.7)",
            "font": "normal 400 16px/1.5 --fontFamily-sans",
            "lg-text-align": "left",
            "lg-margin": "0px 0px 40px 0px",
            "sm-text-align": "left",
            "children": "Test every algorithm on years of market history before risking real money."
        }
    },
    "text4": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "color": "#ffffff",
            "font": "normal 700 24px/1.3 --fontFamily-sans",
            "lg-text-align": "left",
            "sm-text-align": "left",
            "children": "Autopilot trading 24/7"
        }
    },
    "text5": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 40px 0px",
            "color": "rgba(255, 255, 255, 0.7)",
            "font": "normal 400 16px/1.5 --fontFamily-sans",
            "lg-text-align": "left",
            "lg-margin": "0px 0px 40px 0px",
            "sm-text-align": "left",
            "children": "Run your strategy in the cloud — it will trade on its own, even when your computer or phone is off."
        }
    },
    "text6": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 12px 0px",
            "color": "#ffffff",
            "font": "normal 700 24px/1.3 --fontFamily-sans",
            "lg-text-align": "left",
            "sm-text-align": "left",
            "children": "Instant developer support"
        }
    },
    "text7": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 40px 0px",
            "color": "rgba(255, 255, 255, 0.7)",
            "font": "normal 400 16px/1.5 --fontFamily-sans",
            "lg-text-align": "left",
            "lg-margin": "0px 0px 40px 0px",
            "sm-text-align": "left",
            "children": "Don't face challenges alone. Get fast answers to your questions directly in our Telegram chat."
        }
    }
};

const CdzvBenefits = props => {
    const {
        override,
        children,
        rest
    } = useOverrides(props, overrides, defaultProps);
    return <Section {...rest}>
        <Override
            slot="SectionContent"
            flex-direction="row"
            flex-wrap="wrap"
            sm-min-width="280px"
            background="rgba(255, 255, 255, 0)"
        />
        <Box {...override("box")}>
            <Image {...override("image")} />
        </Box>
        <Box {...override("box1")}>
            <Text {...override("text")} />
            <Text {...override("text1")} />
            <Text {...override("text2")} />
            <Text {...override("text3")} />
            <Text {...override("text4")} />
            <Text {...override("text5")} />
            <Text {...override("text6")} />
            <Text {...override("text7")} />
        </Box>
        {children}
    </Section>;
};

Object.assign(CdzvBenefits, {
    ...Section,
    defaultProps,
    overrides
});
export default CdzvBenefits;